import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
   
    isLoading = new Subject<boolean>();
    show() {
     
        this.isLoading.next(true);
        debugger
    }
    hide() {
      debugger
        this.isLoading.next(false);
    }

}
